export default Object.freeze({
  SOLUTION: 0,
  CONDITION: 1,
  VIDEO: 2,
  AUDIO: 3,
  LESSON: 4,
});